import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { MessageService } from 'src/app/service/common/message.service';
import { SupportService } from 'src/app/service/common/support.service';
import { BarristerService } from 'src/app/service/pages/barrister.service';
import { UserService } from 'src/app/service/pages/user.service';

@Component({
  selector: 'app-user-modal',
  templateUrl: './user-modal.component.html',
  styleUrls: ['./user-modal.component.css']
})
export class UserModalComponent implements OnInit {

  private _subs : Subscription = new Subscription();
  titles : any;
  barristers : any;
  userTypes : any;
  designations : any;

  constructor(
    private supportService : SupportService,
    private userService : UserService,
    private msg : MessageService,
    private barristerService : BarristerService,
    private dialogRef : MatDialogRef<UserModalComponent>,
  ) { 
  }

  ngOnInit(): void {
    this._subs.add(
      this.supportService.getNames('titles').subscribe(res => {
        this.titles = res.data;
      })
    )
    this._subs.add(
      this.supportService.getNames('userTypes').subscribe(res => {
        this.userTypes = res.data;
      })
    )
    this._subs.add(
      this.supportService.getNames('designations').subscribe(res => {
        this.designations = res.data;
      })
    )
    this.barristerService.getBarristers('Solicitor', '1').subscribe(res => {
      this.barristers = res.data;
    })
  }
  
  saveUser(data){
    this._subs.add(
      this.userService.saveUser(data).subscribe(res=>{
        if(res.status == 'ok'){
          this.msg.success(res.message);
          this.dialogRef.close(res.data);
        }else{
          this.msg.error(res.message);
        }
      })
    )
  }

  closeModal(){
    this.dialogRef.close(null);
  }

}
